import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import InformedConsentsList from './InformedConsentsList';

loadDOMComponent({
	selector: 'react-informed-consents-list',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const userId = container.getAttribute('userId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<InformedConsentsList userId={userId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
